import React, { useState, useEffect, Fragment, useContext } from "react";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import { Button } from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import Layout from 'components/sales/layout/layout';
import CardSection from 'components/sales/cardSection/cardSection';
import DivLayout from 'components/sales/divLayout/divLayout';
import { toast } from "react-toastify";

const ClientChange = ({ match, getAllClients, clientList, getAddressClient, setAddressClient }) => {
    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [clientAdd, setClientAdd] = useState([]);
    const [data, setData] = useState({ lead_id: parseInt(match.params.lead_id), comm_id: parseInt(match.params.comm_id), client_id: null, address_id: null })

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getAllClients(match.params.lead_id)
            setIsLoading(false)
        })()
    }, [])

    // useEffect(() => {
    //     if(data?.client_id!=null || data?.client_id!=''){
    //         (async () => {
    //             setIsLoading(true)
    //             setClientAdd(await getAddressClient(data?.client_id))
    //             setIsLoading(false)
    //         })()
    //     }
    // }, [data?.client_id])

    const handleSelectClient = async (clientId) => {
        setIsLoading(true)
        const clientData = await getAddressClient(clientId);
        setIsLoading(false);
        if(clientData.length === 0){
            toast.error('No Addresses found for this client.')
            return false;
        }
        setData({ ...data, client_id: clientId })
        setClientAdd(clientData);
    }

    const handleSubmit = () => {
        if (data?.client_id == null || data?.address_id == null) {
            toast.error('Map Client')
            return;
        }
        else {
            (async () => {
                setIsLoading(true)
                const res = await setAddressClient(data)
                const isSuccess =
                    Number(res?.status) === 0 ||
                    (res?.status_code != null && res?.status_code !== 500 && Number(res?.status) !== 1)
                if (isSuccess) {
                    setIsModal(true)
                }
                else {
                    toast.error(res?.message)
                }
                setIsLoading(false)
            })()
        }
    }

    useEffect(()=>{
        if(data?.address_id != null)
            handleSubmit()
    },[data?.address_id])
    return (
        <Layout
            title={localization.contractListing}
            isGoback
            isLoading={isLoading}
        >
            {clientList &&
                <div className="panel-card card-details" width="100%">
                    <div className="panel-heading">Change Client</div>
                    <div className="panel-body">
                        <div className="details-listing detail_alignment">
                            <div className='row'>
                                <div className='col-md-12'>
                                    <DropDownInput
                                        data={clientList}
                                        label="All Clients"
                                        required
                                        errorMsg={localization.requiredName}
                                        getIdValue={(val) => {
                                            // setData({ ...data, client_id: val.id })
                                            if(val?.id){
                                                handleSelectClient(val.id);
                                            }
                                        }}
                                    />
                                </div>
                                {data?.client_id && clientAdd.map((value, index) => {
                                    return (
                                        <CardSection title={localization.address + ' ' + (index + 1)} key={index}>
                                            <div className="details-listing">
                                                <DivLayout
                                                    heading={localization.addressLine1}
                                                    data={value.address_line_1}
                                                />
                                                <DivLayout
                                                    heading={localization.addressLine2}
                                                    data={value.address_line_2}
                                                />
                                                <DivLayout
                                                    heading={localization.city}
                                                    data={value.city_name}
                                                />
                                                <DivLayout
                                                    heading={localization.state}
                                                    data={value.state_name}
                                                />
                                                <DivLayout
                                                    heading={localization.pinCode}
                                                    data={value.pincode}
                                                />
                                                <DivLayout
                                                    heading={localization.clientGST}
                                                    data={value.client_gst}
                                                />
                                                <DivLayout
                                                    heading={localization.addressCreatedBy}
                                                    data={value.name}
                                                />
                                                
                                                <div className='col-md-12' style={{ 'padding': '15px 0px 15px 0px' }}>
                                                    <button onClick={() => { setData({ ...data, address_id: value.id }); }} className='btn btn-primary btn-green'>Map Client Address</button>
                                                </div>
                                            </div>
                                        </CardSection>)
                                })

                                }
                            </div>
                        </div>
                    </div>
                </div>}

            <ModalPop
                title=""
                show={isModal}
                handleModalHide={() => { setIsModal(false); window.location.href = `${baseUrl}/finance-contract-listing` }}
            >
                <div className="text-center">
                    <div className="success">
                        <img src={Images?.tick} alt="" />
                    </div>
                    <h5>Client Changed Successfully</h5>
                    <Link to={`${baseUrl}/finance-contract-listing`} className="btn btn-primary mb-4">View Contract Listing</Link>
                </div>
            </ModalPop>
        </Layout>
    )
}

export default ClientChange